
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.333 12.333L9.967 13.6l3.966-1.233a.762.762 0 00-.241-.259.62.62 0 00-.359-.108H9.967c-.3 0-.54-.011-.717-.033a2.64 2.64 0 01-.55-.134l-1.55-.516.367-1.3 1.35.45c.189.055.41.1.666.133.256.033.634.056 1.134.067a.632.632 0 00-.109-.35.502.502 0 00-.258-.217L6.4 8.667H5.333v3.666zm-4 2.334V7.333H6.4c.078 0 .156.009.233.025.078.017.15.036.217.059l3.917 1.45c.366.133.664.366.891.7.228.333.342.7.342 1.1h1.333a1.99 1.99 0 011.417.55c.389.366.583.85.583 1.45v.666L10 15l-4.667-1.3v.967h-4zm1.334-1.334H4V8.667H2.667v4.666zM11.667 5.5c-.34 0-.628-.113-.866-.34a1.1 1.1 0 01-.357-.827c0-.324.12-.6.357-.826.238-.227.526-.34.866-.34.34 0 .628.113.865.34a1.1 1.1 0 01.357.826c0 .324-.119.6-.357.827-.237.227-.526.34-.865.34zM8.815 6.667a.804.804 0 01-.576-.229.732.732 0 01-.239-.55v-3.11c0-.214.08-.397.24-.55A.804.804 0 018.814 2h5.704c.224 0 .415.076.575.228.16.153.24.336.24.55v3.11c0 .215-.08.398-.24.55a.804.804 0 01-.575.229H8.814zm.815-.778h4.074c0-.214.08-.397.24-.55a.803.803 0 01.574-.228V3.556a.803.803 0 01-.575-.229.732.732 0 01-.24-.55H9.63c0 .215-.08.398-.24.55a.804.804 0 01-.575.229V5.11c.224 0 .416.076.575.229.16.152.24.335.24.549z","fill":"currentColor"}})])
          )
        }
      }
    